var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.list),function(union){return _c('union-label',{key:union.name,staticClass:"ml-2",attrs:{"logo":union.logo,"view":_vm.view}},[_vm._v(" Учасник спілки "+_vm._s(union.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }